/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Submit_CreateInputs */

const vi_warehouse_position_submit_create = /** @type {(inputs: Warehouse_Position_Submit_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo`)
};

/**

* @param {Warehouse_Position_Submit_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_submit_create = /** @type {((inputs?: Warehouse_Position_Submit_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Submit_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_submit_create(inputs)
});